import { authHeader } from '../_helpers/auth-header';
import Config from '../_helpers/config'
export const ProductService = {
    fetchData
};

function fetchData(id) {

    const base_url = `${Config.ApiUrl}/products/sales/detail`;
    const init = { method: 'GET', accept: 'application/json', headers: authHeader() };

    return fetch(`${base_url}?id=${id}`, init)

}


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}